import React from 'react';
import { Alert } from '@trellixio/roaster-coffee';
import Locales from 'locales';

const LockedPlatformAlert = () => {
  return <Alert message={Locales.base.alert.platform_locked} level="warning" />;
};

export default LockedPlatformAlert;
